function About() {
  return (
    <section
      id="about"
      className="py-20 bg-white px-4 text-center"
      data-aos="fade-right" // ✅ Section animation
    >
      <h2
        className="text-4xl font-bold text-gray-800 mb-6"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        About Me
      </h2>

      <div
        className="max-w-3xl mx-auto text-gray-600 text-lg leading-relaxed"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <p>
          I'm a frontend developer with a strong passion for building clean, responsive, and user-friendly web applications. I enjoy working with modern tools like{" "}
          <span className="font-semibold text-blue-600">
            React, Tailwind CSS, and Firebase
          </span>.
        </p>
        <p className="mt-4">
          Currently focused on learning and creating cool side projects, I’m always curious about new technologies and improving my craft. When I’m not coding, you’ll find me brainstorming new ideas or helping friends with their projects.
        </p>
      </div>
    </section>
  );
}

export default About;
